import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { allSharedComponents } from "../../../../../shared";
import { translationConstants, paymentType } from "../../../../../constants";
import { paymentActions } from "../../../../../redux/actions";
import { getUserPayload, unloadWidget } from "../../../../../system";
import {
  TickIcon,
  AddSquareIcon,
  LockIcon,
  EditIcon,
} from "../../../../../assets/images/icon";

import MembershipDetailView from "../Components/MembershipDetailView";

const { BaseForm, CustomModal, SaveCardModal, SaveCard } = allSharedComponents;

const PaymentTab = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userPayload = getUserPayload();

  const profileData = useSelector((state) => state.ProfileReducer.profileData);
  const savedCards = useSelector(
    (state) => state.PaymentReducer.savedPaymentCards?.data
  );
  const [showSaveCardModal, setShowSaveCardModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectCardId, setSelectedCardId] = useState("");

  useEffect(() => {
    dispatch(
      paymentActions.getSavedPaymentCard({
        systemUserId: userPayload?.user?.id,
      })
    );
    // eslint-disable-next-line
  }, [profileData]);

  return (
    <>
      <div className="row w-100">
        <div className="col-md-8 border-vr-right order-1 order-md-0">
          <div className="user-profile">
            <Tabs>
              <TabList>
                <Tab>{t(translationConstants.PRACTITIONER)}</Tab>

                <Tab>{t(translationConstants.INSTRUCTOR)}</Tab>
              </TabList>

              <TabPanel>
                <MembershipDetailView
                  key={paymentType.Membership}
                  isMember={true}
                />
              </TabPanel>

              <TabPanel>
                <MembershipDetailView
                  key={paymentType.Freelance}
                  isFreelancer={true}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
        <div className="col-md-4 p-l-22 p-r-22 order-0 order-md-1">
          <div className="row w-100 membership-border-bottom">
            <div className="col-6 d-flex flex-column">
              <p className="card-detail">
                {t(translationConstants.CARD_DETAILS)}
              </p>
              <span className="card-secured pb-1">
                <img src={LockIcon} alt="img-lock" />
                {t(translationConstants.SECURED_BY)}
              </span>
            </div>
            <div className="col-6 card-div-display justify-content-end">
              <span className="card-update">
                {isUpdate ? (
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      dispatch(
                        paymentActions.updateSavedCard(selectCardId, {
                          systemUserId: userPayload?.user?.id,
                        })
                      );
                      setIsUpdate(false);
                    }}
                  >
                    <img
                      className="height-width-23"
                      src={TickIcon}
                      alt="secure lock icon"
                    />
                  </span>
                ) : (
                  <span
                    className="cursor-pointer"
                    onClick={() => setIsUpdate(true)}
                  >
                    <img
                      className="height-width-25"
                      src={EditIcon}
                      alt="EditIcon"
                    />
                  </span>
                )}
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    setShowSaveCardModal(true);
                  }}
                >
                  <img
                    className="height-width-20"
                    src={AddSquareIcon}
                    alt="AddSquareIcon"
                  />
                </span>
              </span>
            </div>
          </div>
          {savedCards?.map((savedCards) => {
            return (
              <SaveCard
                savedCard={savedCards}
                isUpdate={isUpdate}
                setSelectedCardId={setSelectedCardId}
                selectCardId={selectCardId}
              />
            );
          })}
        </div>
      </div>

      <CustomModal
        scrollable={true}
        size="sm"
        setShow={setShowSaveCardModal}
        show={showSaveCardModal}
      >
        <BaseForm customClass="payment-modal-min-height pt-5">
          <SaveCardModal
            title={t(translationConstants.SAVE_CARD_DETAIL)}
            onCancel={() => {
              setShowSaveCardModal(!showSaveCardModal);
              unloadWidget();
            }}
            onSubmit={() => {
              setShowSaveCardModal(!showSaveCardModal);
              unloadWidget();
            }}
          />
        </BaseForm>
      </CustomModal>
    </>
  );
};

export default PaymentTab;
